<template>
<v-combobox
	v-model="_value"
	item-text="name"
	:items="countries"
	:label="$t('workers.citizenship')"
	persistent-hint
	prepend-icon="mdi-city"
	multiple
	small-chips
	deletable-chips
	return-object
/>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Item from './Item'

export default {
	props: ['value'],
	components: {
		Item
	},
	computed: {
		...mapState({
			settings: ({ settings }) => settings.settings,
			countries: ({ settings }) => settings.countries
		}),
		_value: {
			get() {
				const list = this.value.reduce((acc, item) => {
					const country = this.countries.find(({ code }) => {
						return (item.code || item) === code
					})
					acc.push(country)
					return acc
				}, [])
				return list
			},
			set(val) {
				const country = this.countries.find(
					({ code }) => val[val.length - 1].code === code
				)
				if (!country) {
					const v = val.pop()
					this.$emit('input', v)
				}
				this.$emit('input', val)
			}
		}
	}
}
</script>
